import { render, staticRenderFns } from "./followTmp.vue?vue&type=template&id=260f35ce&scoped=true"
import script from "./followTmp.vue?vue&type=script&lang=js"
export * from "./followTmp.vue?vue&type=script&lang=js"
import style0 from "./followTmp.vue?vue&type=style&index=0&id=260f35ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f35ce",
  null
  
)

export default component.exports